export const INIT_STATE = Object.freeze({
  totalRatings: 0,
  totalReviews: 0,
  overallRating: 0,
  /**
   * @type {Object<string, number>}
   */
  histogram: null,
  /**
   * @type {Object}
   */
  currentUserReview: null,
  isMyReviewLoading: true,
  rnrEndpointsLoading: true,
  shouldShowRnr: true,
});

export const ratingsAndReviewsSlice = (set, get) => ({
  ...INIT_STATE,
});
